import React, { useEffect, useRef, useState } from 'react'
import { Modal, message, Button, Popconfirm } from 'antd'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import listPlugin from '@fullcalendar/list';
import styles from './AllBooking.css'; // Import scoped CSS
import './theme.css'; // 引入主题样式文件
import AddForm from '../../../../components/booking/AddForm';
import UpdateForm from '../../../../components/booking/UpdateForm';
import dayjs from 'dayjs';
import axios from 'axios';
import { connect } from 'react-redux';
import ContentForm from '../../../../components/booking/ContentForm';

function AllBooking(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [isAddModalOpen,setIsAddModalOpen] = useState(false);
  const addForm = useRef();
  const [isUpdateModalOpen,setIsUpdateModalOpen] = useState(false);
  const updateForm = useRef();
  const [selectedDate,setSelectedDate] = useState({start_datetime:dayjs(),end_datetime:dayjs()});//新增時必須帶入的日期
  const [bookingItems,setBookingItems] = useState([]);//可預約項目
  const [events,setEvents] = useState([]);//資料庫回傳的events
  const [renderedEvents,setRenderedEvents] = useState([])//用於渲染events的資料
  const [calendatStartEndDate,setCalendatStartEndDate] = useState({
    start_datetime: '',
    end_datetime: ''
  })//本畫面目前開始以及結束datetime，用在資料庫query目前畫面中的所有資料
  const [selectedData,setSelectedData] = useState({});
  const contentForm = useRef();
  const [isContentModalOpen,setIsContentModalOpen] = useState(false);
  const [isCrossDayVehicleModalOpen,setIsCrossDayVehicleModalOpen] = useState(false);

  const headerToolbar = {
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth',
  };
  const borderColor = {
    1: '#2EA7E0',
    2: '#F23E30'
  }
  const updateCalendatStartEndDate = (val) => {
    const start_datetime = dayjs(val.start).format('YYYY-MM-DD HH:mm:ss');
    const end_datetime = dayjs(val.end).format('YYYY-MM-DD HH:mm:ss');
    setCalendatStartEndDate({
      start_datetime, end_datetime
    })
  }

  useEffect(()=>{
    setRenderedEvents(events.map(item=>{
      return {
        id:item.id,
        title: item.booking_item.name,
        booking_user: item.user_data,
        start: dayjs(item.start_datetime).format('YYYY-MM-DDTHH:mm:ss'),
        end: dayjs(item.end_datetime).format('YYYY-MM-DDTHH:mm:ss'),
        borderColor: borderColor[item.booking_item.type]
      }
    }))

  },[events])

  const getEvents = () => {
    axios.post('/api/query-booking',calendatStartEndDate)
    .then(res=>{
      setEvents(res.data)
    }).catch(err=>{
      console.error('❌ 查詢預約失敗:', err)
    })
  }

  useEffect(()=>{
    axios.get('/api/available-booking-item').then(res=>{
      if(res.data && Array.isArray(res.data) ){
        setBookingItems(res.data)
      }
    }).catch(err => {
      console.error('❌ 載入可預約項目失敗:', err);
    })
  },[])

  useEffect(()=>{
    //依據calendatStartEndDate 進行更新events
    if(calendatStartEndDate.start_datetime !== '' && calendatStartEndDate.end_datetime !== ''){
      getEvents();
    }
  },[calendatStartEndDate])

  const dayHeaderContent = (args) => {
    const options = { weekday: 'short' };
    return <div className="day-header">{Intl.DateTimeFormat('en-US', options).format(args.date)}</div>
}

  function handleEventMount(info) {
    // 获取事件的DOM元素
    const eventElement = info.el;

    // 设置事件的样式，包括行距
    eventElement.style.lineHeight = '18px';
  }

  const renderEventContent = (eventInfo) => {
    const eventTitle = eventInfo.event.title;
    const booking_user = eventInfo.event.extendedProps.booking_user;
    const startTime = dayjs(eventInfo.event.start)
    const endTime = dayjs(eventInfo.event.end)
    const isSameDay = startTime.isSame(endTime, 'day');
    let duration = '';
    if (isSameDay) {
      duration = startTime.format('HH:mm') +' - '+ endTime.format('HH:mm') ;
    }else{
      duration = startTime.format('YYYY/MM/DD HH:mm') +' - '+ endTime.format('YYYY/MM/DD HH:mm') ;
    }

    // 格式化使用者名稱：英文名字(中文名字)，如果沒有中文名字就只顯示英文名字
    const englishName = booking_user.name;
    const chineseName = booking_user.chinese_name;
    const displayName = chineseName
      ? `${englishName.charAt(0).toUpperCase() + englishName.slice(1)}(${chineseName})`
      : englishName.charAt(0).toUpperCase() + englishName.slice(1);

    return (
      <div className="event-details">
        <div className="rectangle" style={{ backgroundColor:eventInfo.event.borderColor }}></div>
        <div className="event-content">
          <b>{eventTitle}</b>
          <b>{displayName}</b>
          {duration}
        </div>
      </div>
    );
  };

  const handleDateClick = (arg) => { // bind with an arrow function
    const currentDatetime = dayjs()
    const selecteDatetime = dayjs(arg.date).set('hour', 10)

    //如果是今天
    if(dayjs(arg.date).format('YYYY-MM-DD') === currentDatetime.format('YYYY-MM-DD')){
      setSelectedDate({
        start_datetime: currentDatetime.add(1, 'hour').set('minute',0).set('second',0),
        end_datetime: currentDatetime.add(3, 'hour').set('minute',0).set('second',0),
      })
    }else{
      //不是今天
      setSelectedDate({
        start_datetime: selecteDatetime,
        end_datetime: selecteDatetime.add(2, 'hour')
      })
    }
    setIsAddModalOpen(true)
  }

  // 檢查是否為跨日車輛預約
  const checkCrossDayVehicle = (bookingItemId, startDate, endDate) => {
    const item = bookingItems.find(i => i.id === bookingItemId);
    if (item && item.type === 2 && startDate !== endDate) {
      setIsCrossDayVehicleModalOpen(true);
    }
  };

  const handleAddOk = ()=>{

    const user = props.user;
    addForm.current.validateFields().then(value=>{

      // 組合日期和時間
      const startDate = dayjs(value.dateRange[0]).format('YYYY-MM-DD');
      const endDate = dayjs(value.dateRange[1]).format('YYYY-MM-DD');
      const startDateTime = `${startDate} ${value.startTime}:00`;
      const endDateTime = `${endDate} ${value.endTime}:00`;

      const bookingData = {
        user_id: user.id,
        booking_item_id: value.booking_item_id,
        start_datetime: startDateTime,
        end_datetime: endDateTime,
        remark: value.remark
      };

      axios.post('/api/booking', bookingData)
      .then(res=>{
        setIsAddModalOpen(false)
        addForm.current.resetFields()
        getEvents();
        // 檢查跨日車輛預約
        checkCrossDayVehicle(value.booking_item_id, startDate, endDate);
      }).catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else if(err.response.status === 409){
          // 使用後端返回的詳細錯誤訊息
          const errorMessage = err.response.data.error || '此時段已被預約，請與預約人協調或預約其他時段。';
          error(errorMessage);
        }
        else{
          error('錯誤，請洽管理員')
        }
      })
    }).catch(err=>{
      error('請輸入完整')
    })
  }

  const handleAddCancel = () => {
    setIsAddModalOpen(false)

  }

  const handleEventClick = (clickInfo) => {
    //找出資料id
    const dataId = Number(clickInfo.event.id)
    //以id找到對應的events中的資料
    const eventData = events.find(item=>item.id === dataId)
    setSelectedData(eventData)

    //確認是否為自己的預約，是的話開啟編輯，管理員也可以編輯
    if(props.user.id === eventData.user_id || props.groupPermission.groupType === 1){
      setIsUpdateModalOpen(true)
    }else{
      setIsContentModalOpen(true)
    }

  };

  const handleUpdateOk = () => {
    updateForm.current.validateFields().then(value=>{

      // 組合日期和時間
      const startDate = dayjs(value.dateRange[0]).format('YYYY-MM-DD');
      const endDate = dayjs(value.dateRange[1]).format('YYYY-MM-DD');
      const startDateTime = `${startDate} ${value.startTime}:00`;
      const endDateTime = `${endDate} ${value.endTime}:00`;

      axios.patch(`/api/booking/${selectedData.id}`,{
        booking_item_id: value.booking_item_id,
        start_datetime: startDateTime,
        end_datetime: endDateTime,
        remark: value.remark
      })
      .then(res=>{
        setIsUpdateModalOpen(false)
        updateForm.current.resetFields()
        getEvents();
        // 檢查跨日車輛預約
        checkCrossDayVehicle(value.booking_item_id, startDate, endDate);
      }).catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else if(err.response.status === 409){
          // 使用後端返回的詳細錯誤訊息
          const errorMessage = err.response.data.error || '此時段已被預約，請與預約人協調或預約其他時段。';
          error(errorMessage);
        }
        else{
          error('錯誤，請洽管理員')
        }
      })
    }).catch(err=>{
      error('請輸入完整')
    })
  }

  const handleUpdateCancel = () => {
    setIsUpdateModalOpen(false)
  }

  const confirm_delete = (e) => {
    //打一個request到後端請求刪除
    axios.delete(`/api/booking/${selectedData.id}`)
    .then(res=>{
      setIsUpdateModalOpen(false)
      updateForm.current.resetFields()
      getEvents();
    }).catch(err=>{
      if(typeof err.response.data.errors === 'object' ){
        let error_meaage = Object.values(err.response.data.errors).join(' ')
        error(error_meaage)
      }else{
        error('錯誤，請洽管理員')
      }
    })
  };


  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };


  return (
    <>
      {contextHolder}
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
        initialView="dayGridMonth"
        editable={false}
        weekends={true}
        headerToolbar={headerToolbar}
        events={renderedEvents}
        dayMaxEventRows={4} // 设置每天最多显示3行事件
        eventContent={renderEventContent}
        eventClick={handleEventClick} // 处理事件点击的函数
        dateClick={handleDateClick}
        contentHeight={620 }
        eventDidMount={handleEventMount}
        dayHeaderContent={dayHeaderContent}
        datesSet={updateCalendatStartEndDate}
      />

      <Modal
        title="新增預約"
        open={isAddModalOpen}
        onOk={handleAddOk}
        onCancel={handleAddCancel}
        centered
        styles={{ body: { maxHeight: '60vh', overflowY: 'auto' } }}
      >
        <AddForm
          ref={addForm}
          selectedDate={selectedDate}
          bookingItems={bookingItems}
        />
      </Modal>
      <Modal
        title="修改預約"
        open={isUpdateModalOpen}
        onCancel={handleUpdateCancel}
        centered
        styles={{ body: { maxHeight: '60vh', overflowY: 'auto' } }}
        footer={[
          <Popconfirm
            key="delete"
            title="確認刪除？"
            onConfirm={confirm_delete}
            okText="Yes"
            cancelText="No"
          >
            <Button danger>Delete</Button>
          </Popconfirm>,
          <Button key="cancel" onClick={handleUpdateCancel}>
            Cancel
          </Button>,
          <Button key="ok" type="primary" onClick={handleUpdateOk}>
            OK
          </Button>,
        ]}
      >
        <UpdateForm
          ref={updateForm}
          selectedUpdateData={selectedData}
          bookingItems={bookingItems}
        />
      </Modal>
      <Modal
        title="提醒"
        open={isCrossDayVehicleModalOpen}
        onOk={()=>{setIsCrossDayVehicleModalOpen(false)}}
        onCancel={()=>{setIsCrossDayVehicleModalOpen(false)}}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>跨日借車成功！請至easyflow填寫跨日借用公務車申請單(已填寫請忽略)</p>
        <a href="https://easyflow.senergy.com.tw/efnet/" target="_blank" rel="noopener noreferrer">
          點此前往 EasyFlow 系統
        </a>
      </Modal>
      <Modal
        title="查看預約"
        open={isContentModalOpen}
        onOk={()=>{setIsContentModalOpen(false)}}
        onCancel={()=>{setIsContentModalOpen(false)}}
      >
        <ContentForm
          ref={contentForm}
          selectedData={selectedData}
          bookingItems={bookingItems}
        />
      </Modal>

    </>
  )
}

const mapStateToProps = ({userProfileReducer: {user,groupPermission}}) => ({
  user,groupPermission
})

export default connect(mapStateToProps)(AllBooking)
